import { Icon } from "@mui/material";
import AuthWall from "modules/AuthWall/AuthWall";
import AuthWallSubscriber from "modules/AuthWallSubscriber/AuthWallSubscriber";
import WorkOrdersPage from "pages/fleet/work-orders";
import DailyInspectionsPage from "pages/fleet/daily-inspections/DailyInspectionsPage";
import CreateDailyInspectionPage from "pages/fleet/daily-inspections/CreateDailyInspectionPage";
import EditDailyInspectionPage from "pages/fleet/daily-inspections/EditDailyInspectionPage";
import FleetSettingsPage from "pages/fleet/fleet-settings";
import CreateVehiclePage from "pages/fleet/vehicles/create";
import EditVehiclePage from "pages/fleet/vehicles/[id]/edit";
import EditWorkOrderPage from "pages/fleet/work-orders/edit";

const fleetRoutes = [
  {
    type: "collapse",
    name: "Fleet Management",
    key: "fleet-management",
    icon: <Icon fontSize="medium">local_shipping</Icon>,
    collapse: [
      {
        name: "Shop Tasks",
        key: "fleet.work-orders",
        route: "/fleet/work-orders",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <WorkOrdersPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Daily Inspections",
        key: "fleet.daily-inspections",
        route: "/fleet/daily-inspections",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <DailyInspectionsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Fleet Settings",
        key: "fleet.fleet-settings",
        route: "/fleet/fleet-settings",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <FleetSettingsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
    ],
  },
  {
    type: "internal",
    name: "Create Daily Inspection",
    key: "fleet.daily-inspections.create",
    route: "/fleet/daily-inspections/create",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <CreateDailyInspectionPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Edit Daily Inspection",
    key: "fleet.daily-inspections.edit",
    route: "/fleet/daily-inspections/:id/edit",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <EditDailyInspectionPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Create Vehicle",
    key: "fleet.vehicles.create",
    route: "/fleet/vehicles/create",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <CreateVehiclePage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Edit Vehicle",
    key: "fleet.vehicles.edit",
    route: "/fleet/vehicles/:id/edit",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <EditVehiclePage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Edit Work Order",
    key: "fleet.work-orders.edit",
    route: "/fleet/work-orders/:id/edit",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <EditWorkOrderPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
];

export default fleetRoutes;
